/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { loadCSS } from 'fg-loadcss';
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import clsx from 'clsx';

import axios from "axios";
import { authHeader } from "_helpers";

import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import Datetime from 'react-datetime';
import { red } from '@material-ui/core/colors';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardAvatar from "components/Card/CardAvatar.js";
import avatar from "assets/img/faces/marc.jpg";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MailIcon from '@material-ui/icons/Mail';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';

import TSSelect from "components/Forms/TSSelect";
import TSSelect2 from "components/Forms/TSSelect2";
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import TSUser from "components/Forms/TSUser"; 
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import TSCheckBox from "components/Forms/TSCheckBox";
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal, ModalBody 
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";


const styles = {};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles((theme) => ({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
      flexGrow: 1,
    },
    cardTitle: {
      textAlign: 'center'
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontFamily: '"Sarabun", sans-serif',
      marginBottom: "3px",
      textDecoration: "none",
      flexGrow: 1,
    },
    collaps:{
      paddingLeft:'40px', 
      paddingTop:'40px',    
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      ...StyleSheet.absoluteFillObject,
      alignSelf: 'flex-end',
      position: 'absolute', // add if dont work with above
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    avatar: {
      backgroundColor: red[500],
    },
    
  }));
  

const Accept = (props) => {

    const AttendeeID = (props.match.params.AttendeeID !== undefined) ? props.match.params.AttendeeID : null;


    var moment = require('moment');
    require('moment/locale/th');
    const [room1, setRoom1] = useState([]);
    const [room2, setRoom2] = useState([]);
    const [room3, setRoom3] = useState([]);
    const [room4, setRoom4] = useState([]);
    const [room5, setRoom5] = useState([]);
    const [roomAll, setRoomAll] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [DefaultDate, setDefaultDate] = useState(moment().format("YYYY-MM-DD"));

    const [MeetingKey, setMeetingKey] = useState(null);
    const [MeetingID, setMeetingID] = useState('');
    const [MeetingName, setMeetingName] = useState("");
    const [StartDatetime, setStartDatetime] = useState('');
    const [EndDatetime, setEndDatetime] = useState('');

    const [StartTme, setStartTime] = useState('');
    const [EndTime, setEndTime] = useState('');
    const [RoomKey, setRoomKey] = useState(null);

    const [AttendStatusKey, setAttendStatusKey] = useState(0);
    const [AttendStatusName, setAttendStatusName] = useState('');


    const [IsUrgent, setIsUrgent] = useState(false);
    const [StartDate, setStartDate] = useState("");
    const [StartType, setStartType] = useState("");

    const [IsMoreDate, setIsMoreDate] = useState(false);
    const [EndDate, setEndDate] = useState("");
    const [EndType, setEndType] = useState("");
    const [MeetingDescription, setMeetingDescription] = useState('');

    const [ContactAddress, setContactAddress] = useState('');
    const [ContactPhone, setContactPhone] = useState('');


    const [modalHoliday, setModalHoliday] = useState(false);
    const [holidayText, setHolidayText] = useState('');
    const [currentDate, setcurrentDate] = useState(moment());
    const [holidays, setHolidays] = useState([]);
    const [Attendee, setAttendee] = useState([]);
    const [toggleEdit, setToggleEdit] = useState(false);

    const [IsCancel, setIsCancel] = useState(false);

    const [modal, setModal] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [modal3, setModal3] = useState(false);
    const [modal4, setModal4] = useState(false);
    const [errMsg, setErrMsg] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [icon, setIcon] = useState("far fa-question-circle");
    const [icon2, setIcon2] = useState("far fa-question-circle");

    const [expanded, setExpanded] = React.useState(true);
    const [isOpen, setIsOpen] = useState(false);

    const [dateFocus, setDateFocus] = useState(false);

    const urgentList = [{ label: "ปกติ", value: 0 }, { label: "ด่วน", value: 1 }, { label: "ฉุกเฉิน", value: 2 }];
    const attendstatus = [{ label: "", value: 0 }, { label: "เข้าร่วม", value: 1 }, { label: "มอบหมายผู้เข้าร่วมแทน", value: 2 },  { label: "ไม่เข้าร่วม", value: 3 }];
    const dateTypeList = [{ label: "ทั้งวัน", value: 0 }, { label: "ครึ่งวันเช้า", value: 1 }, { label: "ครึ่งวันบ่าย", value: 2 }];

    const myRef = useRef(null);

    useEffect(() => {
        const node = loadCSS(
            'https://use.fontawesome.com/releases/v6.3.0/css/all.css',
            document.querySelector('#font-awesome-css'),
          );

        axios.get('/api/v1/meeting/attendee/' + AttendeeID, {headers: { 'referpage': '/meeting/accept' }})
            .then(
                result => {

                    if (result.data.result == 200) {
                        var res = result.data.data;
                        setMeetingID(res.meetingID)
                        setMeetingName(res.meetingName)
                        setStartDatetime(moment(res.startDatetime).format('YYYY-MM-DD').toString())
                        setEndDatetime(moment(res.endDatetime).format('YYYY-MM-DD').toString())
                        setStartTime(moment(res.startDatetime).format('HH:mm'))
                        setEndTime(moment(res.endDatetime).format('HH:mm'))
                        setRoomKey(res.roomKey)
                        setMeetingDescription(res.meetingDescription)
                        setContactPhone(res.contactPhone)
                        //setIcon("far fa-question-circle");
                        //setModalCancel(false)
                        //setModal2(true)
                    }
                    else {
                        alert(result.data.msg)
                        props.history.push({ pathname: '/meeting/index' })

                    }

                },
                error => {


                    props.history.push({
                        pathname: '/auth/login-page',
                        state: {
                            redirect: '/meeting/accept/' + AttendeeID
                        }
                    })

                }
            );

    }, [])


    const handleSubmit = (e, val) => {
  
        e.preventDefault();
        setAttendStatusKey(val);
        var atd = attendstatus.filter(e => e.value == val)[0];
        setAttendStatusName(atd.label);

        if(val == 1 || val == 3)
        {
            var json = {attendStatusKey: val}
            handleConfirm(json);
        }

        
    };

    const handleConfirm = body => {
        
        axios.put('/api/v1/meeting/attendee/' + AttendeeID, body)
        .then(
            result => {

                if (result.data.result == 200) {
                    setModal2(true)
                }
                else {
                    setIcon("far fa-question-circle");
                    setErrMsg(result.data.msg)
                    setModalError(true)
                }

            },
            error => { console.log(error); }
        );  

    };




    const test = e => {
        myRef.current.scrollIntoView()
    };

    const handleStartDate = (date) => {


    }
    const handleExpandClick = () => {
        console.log(expanded)
        setExpanded(!expanded);
      };
  
    const handleEmpData = (_val) => {
        //setExpanded(false);
        setToggleEdit(false);
        var json = {attendStatusKey: AttendStatusKey, standinUserName: _val[0].userName}


        console.log(json);
        handleConfirm(json);

    }



    const classes = useStyles();
    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                    <Card>
                        <CardHeader color="primary">

                            <h4 className={classes.cardTitleWhite}>ตอบรับการประชุม</h4>
                            <p className={classes.cardCategoryWhite}></p>

                        </CardHeader>
                        <CardBody>
                            <Grid>
                                <Col xs={12} sm={6} md={4}>
                                    <div style={{ textAlign: 'center' }}>
                                        เรื่อง : {MeetingName}


                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <div style={{ textAlign: 'center' }}>
                                        วันที่ : {StartDatetime} เวลา : {StartTme} - {EndTime}
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={4}>
                                    <div style={{ textAlign: 'center' }}>
                                        สถานะ : {AttendStatusName}
                                    </div>
                                </Col>

                                <Col xs={12} sm={12} md={12}>
                                    <div style={{ textAlign: 'center' }}>
                                        &nbsp;
                                    </div>
                                </Col>

                            </Grid>
                            
                            <Grid>
                              
                            <Col xs={12} sm={4} md={4} style={{ height: "60px" }}>
                                <Button color="success" onClick={(e)=> handleSubmit(e, 1)} fullWidth>
                                  <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                  <h4>เข้าร่วม</h4>
                                </Button>     
                              </Col>

                              <Col xs={12} sm={4} md={4} style={{ height: "60px" }}>
                                    <Button color="warning" onClick={(e)=> handleSubmit(e,2)} fullWidth>
                                    <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                    <h4>มอบหมายผู้เข้าร่วมแทน</h4>
                                    </Button>
                              </Col>
                              
                              <Col xs={12} sm={4} md={4} style={{ height: "60px" }}>
                                    <Button color="danger" onClick={(e)=> handleSubmit(e,3)} fullWidth>
                                        <i className={"fa fa-save"}  style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }} ></i>
                                        <h4>ไม่เข้าร่วม</h4>
                                    </Button>           
                              </Col>
                          </Grid>


                        </CardBody>
                        <CardFooter>
                            <Collapse isOpen={isOpen}>

                            </Collapse>
                                                    {/* Confirm */}
                        <Modal toggle={() => setModal(false)} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                            <div>
                                <i
                                className={icon}
                                style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                            </div>
                            </div>
                            <ModalBody>
                            <p
                                style={{
                                textAlign: "center"
                                }}
                            >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                ? "ยืนยันการบันทึกข้อมูล"
                                : "กำลังตรวจสอบข้อมูล"}
                            </p>
                            <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                            <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                            >
                                <h4>ยกเลิก</h4>
                            </Button>

                            <Button
                                color="primary"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                            >
                                <h4>ยืนยัน</h4>
                            </Button>
                            </div>
                        </Modal>
                         {/* Success */}
                         <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={() => { setModal2(false);}}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>     
                        {/* Error */}
                        <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                            <div>
                                <i
                                className="fa fa-times"
                                style={{ color: "red", fontSize: "2em" }}
                                ></i>
                            </div>
                            </div>
                            <ModalBody>
                            <p>ไม่สามารถบันทึกข้อมูลได้</p>
                            <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                            <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                            >
                                <h4>ตกลง</h4>
                            </Button>
                            </div>
                        </Modal>
                        </CardFooter>
                    </Card>





                </Col>
            </Grid>
            {(AttendStatusKey == 2) ?                      
            <Grid>

                <Col xs={12} sm={12} md={12}>

                <Card>
                        <CardHeader color="primary" style={{display:'flex', cursor:'pointer'}} onClick={handleExpandClick}>
                            <h4 className={classes.cardTitleWhite}>ผู้เข้าร่วมประชุมแทน {expanded}</h4>
                            <p className={classes.cardCategoryWhite}> </p>
                        
                            <CardActions className={classes.collaps}>
                                <IconButton
                                className={clsx(classes.expand, {
                                    [classes.expandOpen]: expanded,
                                })}
                                onClick={handleExpandClick}
                                aria-expanded={expanded}
                                aria-label="show more"
                                >
                                <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                            
                        </CardHeader>
                        <CardBody>        
                        <Collapse in={expanded} timeout="auto" unmountOnExit>                  
                            <Grid>
                                <Col xs={12} sm={12} md={12}>
                                    <TSUser value={Attendee} isMultiple={false} isShowAll={false} onChange={e => handleEmpData(e)} />
                                </Col>
                            </Grid>
                        </Collapse>  
                    </CardBody>
                    <CardFooter>
                        <Collapse isOpen={isOpen}>
                        </Collapse>
                    </CardFooter>
                </Card>

                </Col>
                        


            </Grid>                            
            :<></>
            }
        </div>
    );
}



export default Accept;